module.exports = __webpack_public_path__ + "img/1641.29d8a585.png";